import React, { useState, useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import 'src/layouts/index.css';
import useStateRef from "react-usestateref";
import EventEmitter from 'src/utils/EventEmitter';
import axios from 'axios';
import CloseIcon from '@mui/icons-material/Close';
import ArrowBackRoundedIcon from '@mui/icons-material/ArrowBackRounded';
import { useSnackbar } from 'notistack';
import { CloseSnackbarAction } from 'src/components/CloseSnackbarAction';
import { CheckExpiredToken } from 'src/components/CheckeExpiredToken';

const MainLayout = () => {
  /* eslint-disable */
  const { enqueueSnackbar } = useSnackbar();
  const [initialized, setInitialized] = useState(false);
  const [showTopNavigation, setShowTopNavigation, showTopNavigationRef] = useStateRef(false);
  const [showNotification, setShowNotification, showNotificationRef] = useStateRef(false);
  const [showHotjarScript, setShowHotjarScript, showHotjarScriptRef] = useStateRef(false);
  const [notificationBanner, setNotificationBanner, notificationBannerRef] = useStateRef("");
  /* eslint-enable */

  /* eslint-disable react-hooks/exhaustive-deps */
  useEffect(() => {
    if (!initialized) {
      setInitialized(true);

      const splash = document.querySelectorAll('.splash');
      setTimeout(() => {
        for (var i = 0; i < splash.length; ++i) {
          splash[i].classList.add('display-none');
        }
      }, 2000)

      // getBannerInfo();
      getGoogleAnalyticsTrackingId();
      // getZendeskWidget();
    }


    const onShowTopNavigation = (eventData) => {
      setShowTopNavigation(eventData.value);
    }

    const listener = EventEmitter.addListener('show_top_navigation', onShowTopNavigation);

    return () => {
      listener.remove();
    }
  });

  // const getBannerInfo = async () => {
  //   try {
  //     await axios
  //       .get(`/csapi/greenship/general/banner`, {
  //         headers: {}
  //       })
  //       .then(async response => {
  //         if (response.data) {
  //           if (response.data.Data) {
  //             if (response.data.Data.length > 0) {
  //               var banner_data = response.data.Data[0];

  //               if (
  //                 (banner_data.showBanner || banner_data.showBanner_Version2) &&
  //                 banner_data.bannerContent != '-'
  //               ) {
  //                 if (banner_data.showBanner) {
  //                   setShowNotification(true);
  //                 }

  //                 setNotificationBanner(banner_data.bannerContent);
  //               }
  //             }
  //           }
  //         }
  //       });
  //   } catch (e) {
  //     setShowNotification(false);
  //     setNotificationBanner('');
  //   }
  // };

  const getGoogleAnalyticsTrackingId = async () => {
    try {
      await axios.get(`/csapi/greenship/general/google-analytics-tracking-id`, {
        headers: {
          "Content-Type": "application/json"
        },
      })
        .then(async response => {
          if (response.data) {
            if (response.data.Data) {
              if (response.data.Data.TrackingId) {
                const script = document.getElementById('google_analytics-script');
                if (script) {
                  script.src = "https://www.googletagmanager.com/gtm.js?id=" + response.data.Data.TrackingId;
                  var content = script.innerHTML;
                  script.innerHTML = content;
                }

                const iframe = document.getElementById('google_analytics-iframe');
                if (iframe) {
                  iframe.innerHTML = '<iframe src="https://www.googletagmanager.com/ns.html?id=' + response.data.Data.TrackingId + ' height="0" width="0" style="display:none;visibility:hidden"></iframe>';
                } else {
                  const new_iframe = document.createElement('noscript');
                  new_iframe.innerHTML = '<iframe src="https://www.googletagmanager.com/ns.html?id=' + response.data.Data.TrackingId + ' height="0" width="0" style="display:none;visibility:hidden"></iframe>';
                  new_iframe.id = "google_analytics-iframe";
                  document.body.appendChild(new_iframe);
                }

              }
            }
          }
        })
    } catch (e) {
    }
  }

  const getZendeskWidget = async () => {
    try {
      var area = "Cannatrek";
      var key = "ZendeskWidgetKey";

      await axios.get(`/csapi/settings?Area=${area}&Key=${key}`, {
      }).then(async response => {
        if (response) {
          if (response.data) {
            var data = response.data.Data.ZendeskWidgetKey;
            if (data) {
              const script = document.getElementById("ze-snippet");
              const url = "https://static.zdassets.com/ekr/snippet.js?key=" + data;
              script.setAttribute("src", url);
            }
          }
        }
      })
    }
    catch (e) {
      var error_message = e.response ? e.response.data ? e.response.data.Message ? e.response.data.Message : e.response.data : e.response.statusText : e.message;

      var is_token_expired = CheckExpiredToken(error_message);

      if (!is_token_expired) {
        enqueueSnackbar(error_message, { variant: 'error', autoHideDuration: 2000, preventDuplicate: true, action: CloseSnackbarAction });
      }
    }
  }

  const getHotJarScript = async () => {
    try {
      var area = "Cannatrek";
      var key = "HotJar_Id";

      await axios.get(`/csapi/settings?Area=${area}&Key=${key}`, {
      }).then(async response => {
        if (response) {
          if (response.data) {
            var data = response.data.Data.HotJar_Id;
            var location = window.location.pathname;
            if (data) {
              if (!(location === "/checkout" || location === "/invoices")) {
                const script = document.createElement("script");
                script.setAttribute("id", "hotjar-snippet");

                script.innerHTML = `
              (function(h,o,t,j,a,r){

                h.hj=h.hj||function(){(h.hj.q=h.hj.q||[]).push(arguments)};
        
                h._hjSettings={hjid:${data},hjsv:6};
        
                a=o.getElementsByTagName('head')[0];
        
                r=o.createElement('script');r.async=1;
        
                r.src=t+h._hjSettings.hjid+j+h._hjSettings.hjsv;

                r.setAttribute("id", "hotjar-snippet")
        
                a.appendChild(r);
        
            })(window,document,'https://static.hotjar.com/c/hotjar-','.js?sv=');`

                document.head.appendChild(script)
              }
            } else {
              setShowHotjarScript(true);
            }
          }
        }
      })
    }
    catch (e) {
      var error_message = e.response ? e.response.data ? e.response.data.Message ? e.response.data.Message : e.response.data : e.response.statusText : e.message;

      var is_token_expired = CheckExpiredToken(error_message);

      if (!is_token_expired) {
        enqueueSnackbar(error_message, { variant: 'error', autoHideDuration: 2000, preventDuplicate: true, action: CloseSnackbarAction });
      }
    }
  }

  useEffect(() => {
    checkLocation();
  }, [window.location.pathname]);

  const checkLocation = () => {
    const location = window.location.pathname;

    if (location === "/forgot-password" || location.includes("/email-verification")) {
      setShowTopNavigation(true);
    } else {
      setShowTopNavigation(false);
    }

    if (!showHotjarScriptRef.current) {
      if (location.includes("/checkout") || location.includes("/invoices")) {
        if (document.querySelectorAll("#hotjar-snippet")) {
          document.querySelectorAll("#hotjar-snippet").forEach(script => script.remove());
        }
      } else {
        if (document.querySelectorAll("#hotjar-snippet").length === 0) {
          getHotJarScript();
        }
      }
    }
  }

  const onClickBackArrow = () => {
    EventEmitter.emit("prev_step", { value: true });
  }

  const getBannerContent = () => {
    var string = notificationBannerRef.current;
    var value_list = string.split("<br/>");

    const list = [];

    /* eslint-disable array-callback-return */
    value_list.map((value, index) => {
      list.push(<span>{index !== 0 ? <br /> : ''}{value}</span>)
    })
    /* eslint-enable array-callback-return */
    return <>{list}</>;
  }

  return (
    <div style={{ height: "100%", width: "100%", minHeight: "-webkit-fill-available", minWidth: "-webkit-fill-available" }}>
      {showNotificationRef.current ?
        <div className="notification-layout notification-layout-1 notification-layout-new">
          <div className="content" style={{ position: "relative" }}>
            <div className="content-wrapper">
              <div className="new-content-wrapper-2">
                <div className="new-notification-wrapper-desktop">
                  <div>
                    <img src="/static/images/icon/warning-icon-yellow.svg" alt="warning-icon-yellow" className="warning-icon-yellow" />
                  </div>
                  <div className="new-notification-wrapper-text" style={{ display: "flex", alignItems: "center" }}>
                    {getBannerContent()}
                  </div>
                </div>
                <div className="new-notification-wrapper-mobile">
                  <div className="new-notification-wrapper-text">
                    {getBannerContent()}
                  </div>
                </div>
              </div>
            </div>
            <div className="close-content new" onClick={() => setShowNotification(false)}><CloseIcon /></div></div>
        </div>
        : ''}

      {showTopNavigationRef.current ?
        // <div className="back_arrow back-arrow-2"><i className="icon-arrow-left" style={{ fontSize: "16px" }} onClick={() => onClickBackArrow()}></i></div>
        <div className="topbar-navigation-wrapper hide-desktop">
          <div className="required-arrow-left hide-desktop navigation" style={{ marginLeft: "0px", marginRight: "0px" }} onClick={() => onClickBackArrow()}>
            <ArrowBackRoundedIcon style={{ fontSize: "20px", marginLeft: "-2px" }} />
          </div>
        </div>
        : ''
      }

      <Outlet />
      {/* <div style={{ height: "20px", minHeight: "20px" }}></div> */}
    </div>
  );
};

export default MainLayout;